import React, { FC } from 'react'
import styles from '../../threePsStyles.module.css'

interface ExtraElementProps {
    primaryColor: string
    entriesLength: number
}

export const ExtraElement: FC<ExtraElementProps> = ({ primaryColor, entriesLength }) => {
    return (
        <div
            className={styles.accordionHeaderExtraElement}
            style={{ backgroundColor: primaryColor }}
        >
            {entriesLength}
        </div>
    )
}
